import React from 'react';
import {
  Box,
  Button,
  Flex,
  Tr,
  Td,
  Text,
  useToast,
  Select,
  Spacer,
  Input,
  Tooltip,
} from '@chakra-ui/react';
import style from '../components/common/style';
import { TableComp } from '../components/common/table';
import {
  listTermConditionManagement,
  colTermConditionManagement,
} from '../context/data';
import { MiniHeader } from '../components/common/customComponent';
import { useHistory } from 'react-router-dom';
import { ChecktableTwo } from '../components/common/ChecktableTwo';
import ApiManager from '../config/apiManager';
// import { deleteItem } from './BannerTypes';
import LangContext from '../context/languageContext';
import { options } from '../context/data';
import {
  ArrowUpIcon,
  ArrowDownIcon,
  EditIcon,
  DeleteIcon,
} from '@chakra-ui/icons';

const TermConditionManagement = () => {
  let history = useHistory();
  const [dataa, setDataa] = React.useState([]);
  const { currentLangData } = React.useContext(LangContext);
  const [value, setValue] = React.useState('10');
  const [paginat, setpaginate] = React.useState();
  const [loader, setLoader] = React.useState(false);
  const [success, setSuccess] = React.useState(null);
  let apimanager = ApiManager.getInstance();
  const toast = useToast();
  // Creating Variable //
  let tempArray = [];

  const handleOnChange = (evt, key) => {
    const ev = evt.target.value;
    // console.log("event", ev)
    setValue(ev);
  };
  // console.log("dataaa>>>",dataa)
  React.useEffect(() => {
    getALLItems(value, 1);
  }, [value]);

  const ArrowUp = ID => {
    let index = dataa.findIndex(e => e._id == ID); //find id from Api
    // console.log("Index",index,"id",ID)
    if (index > 0) {
      let el = dataa[index];
      dataa[index] = dataa[index - 1];
      dataa[index - 1] = el;
      // console.log("EL>>",el,"Up>>>",dataa[index])
      setDataa([...dataa]);
    }
  };

  const ArrowDown = ID => {
    let index = dataa.findIndex(e => e._id == ID); //find id from Api
    // console.log("Index",index,"id",ID)
    if (index > 0) {
      let el = dataa[index];
      dataa[index] = dataa[index + 1];
      dataa[index + 1] = el;
      // console.log("EL>>",el,"Up>>>",dataa[index])
      setDataa([...dataa]);
    }
  };

  const getALLItems = (limit, page) => {
    setLoader(false);
    const body = {
      numRecord: limit,
      page: page,
    };
    apimanager
      .get('getAllTermsAndConditions', body)
      .then(res => {
        // console.log("res>>",res)
        if (res.message === 8232) {
          res?.record?.docs?.map((value, index) => {
            console.log('check>>>', value);
            tempArray.push(value);
          });
          setDataa(tempArray);
          setpaginate(res?.record);
          setLoader(true);
        }
      })
      .catch(error => {
        console.log('error', error);
        setLoader(true);
      });
  };

  const deleteItem = item => {
    console.log('Deletion done', item.id);
    let apimanager = ApiManager.getInstance();
    const body = {
      id: item._id,
    };
    // console.log('body>>>>', body);
    apimanager
      .post('deleteTermsAndConditions', body)
      .then(response => {
        if (response.message === 8230) {
          setSuccess('Successfully Deleted!');
          toast({
            title: success,
            status: 'success',
            duration: 3000,
            isClosable: true,
            description: `Deleted, Please processed to List!`,
          });
          getALLItems();
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  const navigateToEditPage = editData => {
    console.log('editData=>', editData);
    history.push({
      pathname: '/CreateTermAndConditions',
      state: { data: editData, useEditApi: true },
    });
  };

  return (
    <Flex flexDirection={'column'}>
      <Flex {...style.miniheader}>
        {MiniHeader({
          title: 'Term & Condition  list',
          path: 'Dashboard',
          onclickForRoute: () => history.push('/Dashboard'),
          path2: 'Term & Condition Management',
        })}
      </Flex>
      <Flex {...style.box} background={'#fafdfb'} padding={10}>
        <Flex {...style.main}>
          <Flex {...style.buttoncontainer}>
            <Button
              {...style.createbutton}
              onClick={() => history.push('/CreateTermAndConditions')}
            >
              Create
            </Button>
            <Button
              {...style.previewbutton}
              onClick={() => history.push('/TnCUnauth')}
            >
              Preview Html Page
            </Button>
          </Flex>
          <Flex {...style.optionFlex}>
            <Flex {...style.showentries} alignItems={'center'} fontSize={'sm'}>
              <Text>{currentLangData?.app?.show}</Text>
              <Select
                {...style.select}
                // onChange={e => setSelectvalue(e.target.value)}
              >
                {options.map(option => (
                  <option value={option.value}>{option.label}</option>
                ))}
              </Select>
              <Text>{currentLangData?.app?.entries}</Text>
            </Flex>
            <Spacer />
            <Flex alignItems={'center'} {...style.showentries}>
              <Text paddingY={'5px'}>{currentLangData?.app?.search}:</Text>
              <Input {...style.searchinput}></Input>
            </Flex>
          </Flex>
          <ChecktableTwo
            datalist={dataa}
            TotDocs={paginat}
            loaderr={loader}
            headerNames={colTermConditionManagement}
            onPageChange={page => getALLItems(value, page)}
            renderItem={({ item, index }) => {
              // console.log('renderitem', item);
              return (
                <Tr key={index} width={'100%'}>
                  <Td>{item?.tAndcCategory}</Td>
                  <Td>{item?.name}</Td>
                  <Td
                    display={1}
                    justifyContent={'center'}
                    alignItems={'center'}
                  >
                    <ArrowUpIcon
                      w={5}
                      h={5}
                      color={'#ffa426 '}
                      cursor={'pointer'}
                      onClick={() => {
                        ArrowUp(item._id);
                      }}
                    />
                    <ArrowDownIcon
                      w={5}
                      h={5}
                      color={'#ffa426 '}
                      cursor={'pointer'}
                      onClick={() => {
                        ArrowDown(item._id);
                      }}
                    />
                  </Td>
                  <Td
                    position={'relative'}
                    display={'inline-flex'}
                    verticalAlign={'middle'}
                  >
                    <Tooltip label={currentLangData?.app?.edit}>
                      <Button
                        {...style.editbtn}
                        leftIcon={<EditIcon />}
                        onClick={() => navigateToEditPage(item)}
                      ></Button>
                    </Tooltip>
                    <Tooltip label={currentLangData?.app?.delete} bg={'red'}>
                      <Button
                        {...style.Delbtn}
                        leftIcon={<DeleteIcon />}
                        onClick={() => deleteItem(item)}
                      ></Button>
                    </Tooltip>
                  </Td>
                </Tr>
              );
            }}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default TermConditionManagement;
